import { useContext } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { DropsContext } from 'contexts/DropsContext';
import { EntidadesContext } from 'contexts/EntidadesContext';
import { useModal } from 'components/Modals';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';

const CopyModal = ({ usuario, callback }) => {
  const defaultValues = {
    entidade_id_origem: usuario?.id,
    entidade_ids_destino: [],
  };
  const { closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { postLoading, postEntidadePerfilCopia } = useContext(EntidadesContext);
  const { control, handleSubmit } = useForm({ defaultValues });
  const usuarios = (drops?.EntidadeTipo || []).filter(
    (item) =>
      item?.tipo === 'USUARIO' && String(item?.value) !== String(usuario?.id)
  );

  const onSubmit = async (data) => {
    postEntidadePerfilCopia({ data, cb: callback });
  };

  return (
    <>
      <DialogTitle>Exportar/Copiar Perfil do Usuário</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color="text.secondary">Usuário de origem</Typography>
            <Typography>{usuario?.nome}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography color="text.secondary">
              Selecione os usuários aos quais o perfil de {usuario?.nome} será
              aplicado.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Dropdown
              multiple
              control={control}
              options={usuarios}
              name="entidade_ids_destino"
              label="Usuários de destino"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          loading={postLoading}
          onClick={handleSubmit(onSubmit)}
        >
          Confirmar
        </Button>
        <Button variant="contained" onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default CopyModal;
